import yup from 'yup'

export default yup.object().shape({
  hostname: yup.string().required("hostname can't be blank")
})



// WEBPACK FOOTER //
// ./src/validations/server.js